import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { ClientService } from "../../../services/ClientService";
import Select, { ActionMeta, createFilter } from "react-select";
import { Endpoints } from "../../../helpers/Endpoints";
import { useCallback } from "react";
import { Attorney } from "../../../models";
import Button from "react-bootstrap/Button";
import { Globals } from "../../../helpers/globals";
import AttorneySyncModal from "./components/modal/AttorneySyncModal";
import Profile from "./components/Profile";
import { join } from "path";

type OrgOptionType = { label: string; value: string };
type FirmOptionType = { label: string; value: string };
type NameValueOptionType = { label: string; value: string };

export default function AttorneysPage() {
    const { active } = useParams<{ active?: string }>();

    const currentUser = Globals.currentUserValue;
    const never = "never" as const;
    const onInsert = "onAdd" as const;
    let options: NameValueOptionType[] = [];
    const [data, setData] = useState([] as APIModels.Attorney[]);
    const [firmId, setFirmId] = useState("");
    const [firmOptions, setFirmOptions] = useState(options);
    const [rowdata, setRow] = useState([] as APIModels.Attorney[]);

    //sync
    const [attorney, setAttorney] = useState(new APIModels.Attorney());
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        ClientService.myFirms().then(
            (resp) => {
                if (resp.successful && resp.data) {
                    options = resp.data.map((v, i) => {
                        return { value: v.id!, label: v.name! };
                    });
                    setFirmOptions(options);
                    if (options.length == 1) {
                        setFirmId(options[0].value);
                    }
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        if (firmId != "") {
            ClientService.firmAttorneys({ firmId: firmId! }).then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        setData(resp.data);
                    } else {
                        //TODO: Show error
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [firmId]);

    const filterOption = (
        option: NameValueOptionType,
        inputValue: string
    ): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    const onFirmChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setFirmId(value?.value ?? "");
    };

    const onEdit = (rowdata: APIModels.Attorney) => {
        window.location.href = `/admin/attorneyedit/${rowdata.id}`;
        console.log(rowdata.id);
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Attorneys</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Attorneys
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {currentUser?.role && currentUser.role!.key! >= 700 && (
                    <>
                        <AttorneySyncModal
                            showModal={showModal}
                            setShowModal={setShowModal}
                        />
                    </>
                )}
                <div className="row mb-3">
                    <div
                        className="col-4"
                        style={{ maxWidth: "75%", zIndex: 50 }}
                    >
                        <label htmlFor="selFirm" className="form-label">
                            Firm
                        </label>
                        {firmOptions.length === 1 ? (
                            <Select
                                id="selFirm"
                                name="selFirm"
                                value={firmOptions[0]}
                                options={firmOptions}
                                onChange={onFirmChange}
                            />
                        ) : (
                            <Select
                                id="selFirm"
                                name="selFirm"
                                filterOption={filterOption}
                                options={firmOptions}
                                onChange={onFirmChange}
                            />
                        )}
                    </div>
                    <div
                        className="col-2"
                        style={{
                            zIndex: 50,
                            position: "absolute",
                            right: "-30px",
                        }}
                    >
                        <button
                            className="btn btn-primary"
                            onClick={() => setShowModal(true)}
                        >
                            <i className="ri-repeat-line"></i> Sync
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%", zIndex: 20 }}>
                            <MaterialTable
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    { title: "Name", field: "fullName" },
                                    {
                                        title: "State",
                                        field: "state",
                                        editable: "always",
                                    },
                                    {
                                        title: "Email Address",
                                        field: "emailAddress",
                                    },
                                    {
                                        title: "Active",
                                        field: "active",
                                        type: "boolean" as const,
                                    },
                                ]}
                                data={data}
                                title="Attorneys"
                                options={{
                                    actionsColumnIndex: -1,
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                actions={[
                                    {
                                        icon: "edit",
                                        tooltip: "Edit Attorney",
                                        onClick: (event, rowData) =>
                                            //(window.location.href = `/admin/attorneys/edit/Id=${rowData}`),
                                            onEdit(
                                                rowData as APIModels.Attorney
                                            ),
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
